// extracted by css-extract-rspack-plugin
export default {"ButtonRoot":"SnippetSidebarButton-module__ButtonRoot___q30Wz","isSelected":"SnippetSidebarButton-module__isSelected___FvJ8q"};